import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

export const sendMessageAsync = createAsyncThunk(
  'chat/sendMessage',
  async ({ messages, input }, { rejectWithValue }) => {
    try {
      const response = await fetch('https://api.openai.com/v1/chat/completions', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer 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'
        },
        body: JSON.stringify({
          model: 'gpt-3.5-turbo',
          messages: [
            { role: 'system', content: "You are a Suspire assistant. Introduce yourself as such. When answering a question, always start with 'As per Suspire's knowledge base...', 'As per the brand guidelines...', or 'As per my knowledge of standard practices at Suspire...'. When the user asks open-ended questions like how you can help them, reply saying that you are a Suspire assistant and have context on Suspire's processes and brands' success stories on Suspire. Then, list out a set of skills such as onboarding help, tool usage, marketing, etc., formatted neatly with points if applicable. Always ask at the end if the information was useful and if you can assist with anything else." },
            ...messages.map((msg) => ({
              role: msg.user ? 'user' : 'assistant',
              content: msg.user || msg.AI
            })),
            { role: 'user', content: input }
          ],
          max_tokens: 150
        })
      });
      if (!response.ok) {
        return rejectWithValue('API request failed');
      }
      const data = await response.json();
      if (data.choices && data.choices[0] && data.choices[0].message) {
        return data.choices[0].message.content.trim();
      }
      return rejectWithValue('Unexpected API response structure');
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);

const chatSlice = createSlice({
  name: 'chat',
  initialState: {
    messages: [],
    status: 'idle',
    error: null
  },
  reducers: {
    addUserMessage: (state, action) => {
      state.messages.push({ user: action.payload });
    },
    clearChat: (state) => {
      state.messages = [];
      state.status = 'idle';
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(sendMessageAsync.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(sendMessageAsync.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.messages.push({ AI: action.payload });
      })
      .addCase(sendMessageAsync.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload || 'Failed to send message';
      });
  }
});

export const { addUserMessage, clearChat } = chatSlice.actions;
export default chatSlice.reducer;
